
import React from "react";
import { memo, MouseEvent } from "react";
import * as BaseIcons from "./IconSvgs/BaseIconSvgs";
import * as CountryIcons from "./IconSvgs/CountryIconSvg";
import * as MiscellaneousIcons from "./IconSvgs/MiscellaneousIconSvgs";
import * as PaymentIcons from "./IconSvgs/PaymentIconSvgs";
import * as ThumbnalIcons from "./IconSvgs/ThumbnailSvgs";
import styles from "./Icon.module.scss";
import classNamesHelper from "../../helpers/classNameHelper";

const Icons = {
  ...BaseIcons,
  ...CountryIcons,
  ...MiscellaneousIcons,
  ...PaymentIcons,
  ...ThumbnalIcons,
};

export type IconStrings = keyof typeof Icons;

export interface IconProps {
  name: IconStrings;
}
export interface SvgIconConstituentValues {
  id?: string;
  size?: "xxs" | "xs" | "sm" | "md" | "lg";
  color?: string;
  stroke?: string;
  className?: string;
  role?: string;
  onClick?: (e: MouseEvent<SVGSVGElement | HTMLButtonElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<SVGSVGElement>) => void;
  tabIndex?: number;
  title?: string;
}
const defaultIconSize = "sm";

const Icon = memo(function Icon({
  name,
  color,
  size = defaultIconSize,
  className,
  ...props
}: IconProps & SvgIconConstituentValues) {
  const CustomIcon = Icons[name];
  const isBase = Object.prototype.hasOwnProperty.call(BaseIcons, name);

  return (
    <CustomIcon
      id={props.id}
      role={props.role || "icon"}
      stroke={isBase ? color : undefined}
      aria-label={props.title || name}
      className={classNamesHelper([
        styles.icon,
        className,
        styles[size],
        !className && !color && isBase && styles.defaultColor,
      ])}
      onClick={props.onClick}
      title={props.title}
      data-icon={name}
    />
  );
});

export default Icon;
